// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-modal: 250 250 250;

  --transition-duration: 0.15s;

  --z-base: 1;
  --z-modal: 10;
  --z-notifications: 202; /* Above Vuetify overlays */
}

@layer colors {
  @layer levels {
    :root {
      --Low: #9e9eaf;
      --bgLow: color-mix(in oklch, var(--Low), black 20%);
      --onLow: #fff;

      --Medium: #ff9800;
      --bgMedium: color-mix(in oklch, var(--Medium), black 10%);
      --onMedium: #fff;

      --High: #f44336;
      --bgHigh: color-mix(in oklch, var(--High), black 10%);
      --onHigh: #fff;
    }
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
